import React, {FC, useCallback} from 'react';
import {connect} from 'react-redux';

import {ResolveDispatchProps} from '../../../../../../src/helpers/reduxHelpers';
import {CustomFieldResourceTypesEnum} from '../../../../../../src/models/api/customFieldModel';
import {InterfaceEventsEnum, trackInterfaceEvent} from '../../../../../../src/services/tracking';
import {fetchCrmSyncsAsyncAction} from '../../../../../../src/store/data/crmSync/crmSyncsActions';
import {fetchCustomFieldsForResourceTypeAsyncAction} from '../../../../../../src/store/data/customFields/customFieldsActions';
import {makeGetContactsManagerParameterType} from '../../../../../../src/store/panels/contacts/contactsManager/contactsManagerPanelSelectors';
import {ContactsManagerPanelId} from '../../../../../../src/store/panels/panelStateBase';
import {
  makeMapDispatchToProps,
  makeMapStateToProps,
  ResolveStateProps,
} from '../../../../../../srcCommon/helpers/reselectHelpers';
import {useInitialEffect} from '../../../../../shared/helpers/src/react/hooks/useEffectHelpers';
import {ContactsManager} from './contactsManager';
import {ContactsManagerTrackingEvent, ContactsManagerTrackingHandler} from './helpers/trackingHelpers';

/*
 * Props.
 */

interface ContactsManagerContainerPublicProps {
  panelId: ContactsManagerPanelId;
}

interface ContactsManagerContainerComponentProps
  extends ResolveStateProps<typeof mapStateToProps>,
    ResolveDispatchProps<typeof mapDispatchToProps> {
  panelId: ContactsManagerPanelId;
}

/*
 * Component.
 */

const ContactsManagerContainerComponent: FC<ContactsManagerContainerComponentProps> = (props) => {
  const {fetchCustomFieldsForResourceType, fetchCrmSyncsAsync, panelId, parameterType} = props;

  useInitialEffect(() => {
    fetchCustomFieldsForResourceType(CustomFieldResourceTypesEnum.ACCOUNT);
    trackInterfaceEvent(InterfaceEventsEnum.CONTACTS_MANAGER_ACCOUNTS_VIEW);
    fetchCrmSyncsAsync();
  });

  const onTrackHandler = useCallback(
    (event: ContactsManagerTrackingEvent) => ContactsManagerTrackingHandler(parameterType, event),
    [parameterType],
  );

  return <ContactsManager panelId={panelId} onTrackHandler={onTrackHandler} />;
};

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<ContactsManagerContainerPublicProps>()(() => ({
  parameterType: makeGetContactsManagerParameterType(),
}));

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  fetchCustomFieldsForResourceType: fetchCustomFieldsForResourceTypeAsyncAction,
  fetchCrmSyncsAsync: fetchCrmSyncsAsyncAction,
}));

export const ContactsManagerContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ContactsManagerContainerComponent);
